import { SubjectSelector } from "@/components/Questions/SubjectSelector"
import { TagSelector } from "@/components/Quizzes/TagSelector"
import { Box, Input, Stack, Text } from "@chakra-ui/react"
import type { ReactNode } from "react"

export interface QuizFilterSubject {
  id: string
  name: string
}

interface QuizFilterControlsProps {
  search: string
  onSearchChange: (value: string) => void
  selectedSubjects: QuizFilterSubject[]
  onSubjectsChange: (subjects: QuizFilterSubject[]) => void
  availableSubjects?: QuizFilterSubject[]
  selectedTags: string[]
  onTagsChange: (tags: string[]) => void
  additionalFilter?: ReactNode
}

export function QuizFilterControls({
  search,
  onSearchChange,
  selectedSubjects,
  onSubjectsChange,
  availableSubjects,
  selectedTags,
  onTagsChange,
  additionalFilter,
}: QuizFilterControlsProps) {
  return (
    <Stack
      gap={3}
      display="grid"
      gridTemplateColumns={{
        base: "1fr",
        md: additionalFilter
          ? "repeat(4, minmax(0, 1fr))"
          : "repeat(3, minmax(0, 1fr))",
      }}
    >
      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2}>
          Search by test name
        </Text>
        <Input
          aria-label="Search by test name"
          placeholder="Search tests..."
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          size="lg"
        />
      </Box>
      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2}>
          Filter by subject
        </Text>
        <SubjectSelector
          selectedSubjects={selectedSubjects}
          onChange={onSubjectsChange}
          availableSubjects={availableSubjects}
        />
      </Box>
      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2}>
          Filter by tag
        </Text>
        <TagSelector selectedTags={selectedTags} onChange={onTagsChange} />
      </Box>
      {additionalFilter}
    </Stack>
  )
}
